import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { CoreModule } from 'src/app/core/core.module';
import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { MessagesModule } from 'primeng/messages';
import { InputTextarea } from 'primeng/inputtextarea';
import { MediatorsListComponent } from './mediators-list/mediators-list.component';
import { MediatorsDetailComponent } from './mediators-detail/mediators-detail.component';
import { MediatorsRoutingModule } from './mediators-routing.module';
import { DialogModule } from 'primeng/dialog';


@NgModule({ declarations: [
        MediatorsListComponent,
        MediatorsDetailComponent
    ], imports: [CoreModule,
        CommonModule,
        CardModule,
        ButtonModule,
        CheckboxModule,
        InputTextModule,
        PasswordModule,
        FormsModule,
        TableModule,
        CardModule,
        TabViewModule,
        CalendarModule,
        MessagesModule,
        MediatorsRoutingModule,
        ReactiveFormsModule,
        InputTextModule,
        InputSwitchModule,
        ConfirmDialogModule,
        DropdownModule,
        DynamicDialogModule,
        InputTextarea,
        DialogModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class MediatorsModule { }
